import { Injectable } from "@angular/core";
import { InvoiceService } from "./invoice.service";

@Injectable({ providedIn: 'root' })
export class InvoiceCacheService {
  private invoiceList: any[] = [];

  constructor(
    private invoiceService: InvoiceService) {
    
  }

  setInvoices(invoices: any[]) {
    this.invoiceList = invoices;
  }

  getInvoices(): any[] {
    return this.invoiceList;
  }

  getNextInvoice(currentId: number, pharmacyId: number, facilityId: number, patientId: number): any | null {
    const index = this.findCurrentInvoiceIndex(currentId, pharmacyId, facilityId, patientId);
    return index >= 0 && index < this.invoiceList.length - 1
      ? this.invoiceList[index + 1]
      : null;
  }

  getPreviousInvoice(currentId: number, pharmacyId: number, facilityId: number, patientId: number): any | null {
    const index = this.findCurrentInvoiceIndex(currentId, pharmacyId, facilityId, patientId);
    return index > 0
      ? this.invoiceList[index - 1]
      : null;
  }

  updateIdCurrentInvoice(currentId: number, pharmacyId: number, facilityId: number, patientId: number, newInvoice: any): void {
    const index = this.findCurrentInvoiceIndex(currentId, pharmacyId, facilityId, patientId);
    if (index < 0) {
      console.error("Invoice not found");
      return;
    }
    this.invoiceList[index] = newInvoice;
  }

  findCurrentInvoiceIndex(currentId: number, pharmacyId: number, facilityId: number, patientId: number): number {
    return this.invoiceList.findIndex(i =>
      i.id === currentId
      && i.pharmacyId === pharmacyId
      && i.facilityId === facilityId
      && i.patientId === patientId
    );
  }
}
